import React from 'react';
import {SystemStatus, SystemStatusOptions} from "../../../gd/const/system-status";

type Props = {
    size        : 26 | 22,

    // callbacks
    onClick     : callback
    onDelete    : callback       // if set adds delete button
    value       : callback       // this is what being passed when we set on click or on delete !!!

    className   : string
    style?      : any

    // Special cases
    statusId    : SystemStatus
}

export default function PillSystemStatus(props: Props) {

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onDelete) props.onDelete(props.value)
    }

    const status = SystemStatusOptions.find((option: Option)=>option.value === props.statusId)

    const bgClass = 'bg-status-paleBg-'+status?.color
    const txtClass = 'ui5-txt-status-'+status?.color

    const classes = Classes(
        'ui5-pill-u', 'pale',
        bgClass, txtClass,
        's-'+props.size || "26",
        props.className
    );

    return (
        <div className={classes} onClick={onClick}>
            <div className="pill-label">{status?.label}</div>
            {!!props.onDelete && <div className="i5-close" onClick={onDelete} />}
        </div>
    )
}
